import { Link } from "@tanstack/react-router";
import { Facebook, Instagram, Mail } from "lucide-react";
import { NAV_LINKS } from "./Nav";
import { Logo } from "./Logo";
import { locationShortList, useBlock } from "../lib/content";
import { seasonStartLabel } from "../lib/season";
import { ORG_NAME, TAGLINE } from "../lib/site-info";

export function Footer() {
  const contact = useBlock("contact");
  const season = useBlock("season");
  const locations = useBlock("locations");
  const startLabel = seasonStartLabel(season.sessions);
  return (
    <footer className="mt-16 border-t border-border bg-ink text-paper/80">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <Logo tone="mono" className="text-paper" />
          <p className="mt-3 text-sm font-semibold uppercase tracking-[0.18em] text-secondary">
            {TAGLINE}
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            A ministry helping Year 12 leavers across Sydney connect with Jesus, with each other,
            and with the Christian group at their uni.
          </p>
        </div>

        <div className="text-sm">
          <p className="font-heading font-bold text-paper">This season</p>
          <ul className="mt-3 space-y-1.5">
            <li>{startLabel}</li>
            <li>Mondays {season.time}</li>
            <li>{locationShortList(locations.items)}</li>
          </ul>
          <nav aria-label="Footer" className="mt-6 flex flex-wrap gap-x-4 gap-y-2">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="rounded text-paper/70 hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="text-sm">
          <p className="font-heading font-bold text-paper">Get in touch</p>
          <ul className="mt-3 space-y-2">
            <li>
              <a
                href={`mailto:${contact.email}`}
                className="inline-flex items-center gap-2 rounded hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
              >
                <Mail className="h-4 w-4 text-secondary" aria-hidden />
                {contact.email}
              </a>
            </li>
            <li>
              <a
                href={contact.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
              >
                <Instagram className="h-4 w-4 text-secondary" aria-hidden />
                {contact.instagramHandle}
              </a>
            </li>
            <li>
              <a
                href={contact.facebookUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
              >
                <Facebook className="h-4 w-4 text-secondary" aria-hidden />
                {contact.facebookHandle}
              </a>
            </li>
          </ul>
          <Link
            to="/contact"
            className="mt-5 inline-flex rounded text-secondary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
          >
            Send us a message
          </Link>
        </div>
      </div>
      <div className="border-t border-paper/10 py-4 text-center text-xs text-paper/50">
        © {new Date().getFullYear()} {ORG_NAME}
      </div>
    </footer>
  );
}
